import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TenantService } from './tenant.service';
import { AuthService } from '../auth/auth.service';

export interface WeatherNewsSrf {
  date: string; // ISO 8601拡張形式
  wx: number; // 天気コード
  temp: number; // 気温(℃)
  prec: number; // 1時間降水量(mm/h)
  arpress: number; // 気圧(hPa)
  wndspd: number; // 風速(m/s)
  wnddir: number; // 風向(1-16)
  rhum: number; // 相対湿度(％)
}

export interface WeatherNewsMrf {
  date: string; // ISO 8601拡張形式
  wx: number; // 天気コード
  maxtemp: number; // 最高気温(℃)
  mintemp: number; // 最低気温(℃)
  pop: number; // 降水確率(％)
}

export interface WeatherNewsData {
  lat: number;
  lon: number;
  srf: WeatherNewsSrf[];
  mrf: WeatherNewsMrf[];
}

export interface WeatherNewsResponse {
  requestId: string;
  wxdata: WeatherNewsData[];
  errors?: { code: string; message: string }[];
}

@Injectable({
  providedIn: 'root'
})
export class WeatherNewsService {
  private readonly http = inject(HttpClient);
  private readonly tenantService = inject(TenantService);
  private readonly authService = inject(AuthService);

  /**
   * WeatherNews API から天気予報データを取得します
   * @param lat 緯度
   * @param lon 経度
   * @returns 取得したデータ。機能が無効な場合や設定不足の場合は null。
   */
  async getWeather(lat: number, lon: number): Promise<WeatherNewsResponse | null> {
    if (!this.tenantService.hasFeature('weather_news')) {
      return null;
    }

    const { functionsUrl } = environment.weatherNews;

    if (!functionsUrl) {
      console.warn('WeatherNews Functions URLの設定が不足しています');
      return null;
    }

    const user = this.authService.user();
    if (!user) {
      console.error('ユーザーが認証されていません');
      return null;
    }

    try {
      const token = await user.getIdToken();
      const response = await firstValueFrom(
        this.http.get<WeatherNewsResponse>(functionsUrl, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            lat: lat.toString(),
            lon: lon.toString()
          }
        })
      );
      return response;
    } catch (error) {
      console.error('WeatherNews APIの取得に失敗しました', error);
      return null;
    }
  }
}
